import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormLabel from '@material-ui/core/FormLabel'
import ProviderAPI from 'config/api/ProviderAPI'
import { onError } from 'config/lib/errorLib'
import { NotificationManager } from 'react-notifications'

const exampleLead = {
    "firstName": "John",
    "lastName": "Smith",
    "email": "john.smith@example.com",
    "phone": "0891234567",
    "eircode": "D01 F5P2",
    "county": "Dublin",
    "What appeals to you most about solar?": "Reducing my monthly energy bill",
    "How much are your electricity bills?": "€1,200 - €2,000 per year",
    "How much solar would you like?": "Medium (3kW - 5kW)",
    "What's your time frame for getting solar?": "Within 6 months",
    "How many storeys does your house have?": "Two-storey",
    "Are you interested in availing of the solar grant?": "YES"
}

export default function ConfigureWebhook({ company }) {
    const api = new ProviderAPI()
    const [webhookUrl, setWebhookUrl] = useState(company.webhookUrl || '')
    const [loading, setLoading] = useState(false)

    const handleSendTest = async () => {
        setLoading(true)
        try {
            await api.sendTestWebhook(company.companyId, webhookUrl, exampleLead)
            NotificationManager.success('Test lead sent successfully')
        } catch (e) {
            onError(e)
        }
        setLoading(false)
    }

    return (
        <Box width='100%' mb={4}>
            <FormGroup style={{ marginBottom: '1rem' }}>
                <FormLabel>Webhook URL</FormLabel>
                <FormControl variant='filled' component={Box} width='100%'>
                    <OutlinedInput
                        autoComplete='off'
                        type='text'
                        placeholder='https://yourcrm.com/webhook-endpoint'
                        value={webhookUrl}
                        onChange={(e) => setWebhookUrl(e.target.value)}
                    />
                </FormControl>
            </FormGroup>
            <FormGroup style={{ marginBottom: '1rem' }}>
                <FormLabel>Example Payload</FormLabel>
                <Box component='pre' p={2} style={{ backgroundColor: '#f5f5f5', borderRadius: 4, fontSize: '0.85rem' }}>
                    {JSON.stringify(exampleLead, null, 2)}
                </Box>
            </FormGroup>
            <Button
                variant='contained'
                color='primary'
                disabled={!webhookUrl || loading}
                onClick={handleSendTest}
            >
                {loading ? 'Sending...' : 'Send Test Lead'}
            </Button>
            <Box mt={4}>
                <Typography variant="body2">
                    If your CRM does not offer a direct API integration, many CRMs can be connected via 
                    <a 
                        href="https://zapier.com/apps/webhook/integrations" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{ color: '#229626', marginLeft: 4, fontWeight: 500 }}
                    >
                        Zapier
                    </a>. You can use the webhook URL provided by Zapier here to deliver leads into your CRM.
                </Typography>
            </Box>
        </Box>
    )
}